import "./CreateForm.scss";
import axios from "axios";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Dots from "react-activity/dist/Dots";
import { CirclePicker } from "react-color";
import Button from "../components/Button";

function CreateForm() {
  const navigate = useNavigate();
  const [nextPage, setNextPage] = useState(false);
  const [title, setTitle] = useState("");
  const [color, setColor] = useState("#62C188");
  const [picture, setPicture] = useState(null);
  const [questionsArray, setQuestionsArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const slugify = (Text) => {
    let slug = Text.toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");
    return slug
  };

  const handleSaveForm = async () => {
    if (title.length < 6) {
      alert("Votre titre doit comporter au moins 6 caractères");
    } else if (questionsArray.length === 0) {
      alert("Votre formulaire doit contenir au moins une question");
    } else {
      let allFieldsAreFilled = true;
      for (let i = 0; i < questionsArray.length; i++) {
        if (questionsArray[i].question === "") {
          alert("Vos questions ne doivent pas être vides");
          allFieldsAreFilled = false;
          break;
        }
      }
      if (allFieldsAreFilled) {
        setIsLoading(true);
        const slug = slugify(title);
        const existingSlug = await axios.get(
          `https://tell-me-more-backend-nyfc.onrender.com/form/${slug}`
        );
        if (existingSlug.data !== null) {
          alert("Ce titre de formulaire est déja pris");
          setIsLoading(false);
        } else {
          const formData = new FormData();

          formData.append("title", title);
          formData.append("slug", slug);
          formData.append("picture", picture);
          formData.append("color", color);

          const stringifiedQuestionsArray = JSON.stringify(questionsArray);

          formData.append("questionsString", stringifiedQuestionsArray);

          const response = await axios.post(
            "https://tell-me-more-backend-nyfc.onrender.com/form/create",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          console.log(response.data);
          setIsLoading(false);
          alert("Votre formulaire a bien été créé");
          navigate(`/backoffice/update/${response.data._id}`);
        }
      }
    }
  };

  return isLoading ? (
    <Dots />
  ) : (
    <div className="createFormContainer">
      <div className="createFormTop">
        <Link className="link" to={"/backoffice"}>
          Formulaires
        </Link>
        <input
          type="text"
          placeholder="Veuillez renseigner un nom de formulaire"
          onChange={(e) => {
            setTitle(e.target.value);
          }}
        />
        <div>
          <Button
            text={"Supprimer"}
            color={"red"}
            func={() => {
              navigate("/backoffice");
            }}
            show={true}
          />
          <Button
            text={"Sauvegarder"}
            color={"green"}
            func={handleSaveForm}
            show={true}
          />
        </div>
      </div>
      <div className="createFormBottom">
        <div className="formCreateNav">
          <nav
            className={nextPage === true ? "greenNav" : undefined}
            onClick={() => {
              setNextPage(false);
            }}
          >
            Questions
          </nav>
          <nav
            className={nextPage === false ? "greenNav" : undefined}
            onClick={() => {
              setNextPage(true);
            }}
          >
            Personnaliser le formulaire
          </nav>
        </div>
        {nextPage ? (
          <div className="nextPageContainer">
            <div className="circleDiv">
              <CirclePicker
                circleSize={80}
                colors={["#62C188", "#5D92BE", "#FF8138", "#B33FD6"]}
                onChange={(color) => setColor(color.hex)}
              />
              <p>Couleur du formulaire</p>
              <div
                className={
                  color === "#b33fd6"
                    ? "currentColor colorPurple"
                    : color === "#ff8138"
                    ? "currentColor colorOrange"
                    : color === "#5d92be"
                    ? "currentColor colorBlue"
                    : "currentColor colorGreen"
                }
              ></div>
            </div>
            <div>
              {picture === null ? (
                <div>
                  <label for="file" className="picFile">
                    Ajouter une image
                  </label>
                  <input
                    id="file"
                    className="input-file"
                    type="file"
                    onChange={(e) => setPicture(e.target.files[0])}
                  />
                </div>
              ) : (
                <div className="imageDiv">
                  <img
                    className="image"
                    src={URL.createObjectURL(picture)}
                    alt={""}
                  />
                  <Button
                    text={"Supprimer l'image"}
                    color={"red"}
                    func={() => {
                      setPicture(null);
                    }}
                    show={true}
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <div>
            <div className="questionsContainer">
              {questionsArray.map((item, index) => {
                return (
                  <div key={index} className="questionDiv">
                    <div
                      className={
                        item.category === 1
                          ? "iconDiv icon1"
                          : item.category === 2
                          ? "iconDiv icon2"
                          : item.category === 3
                          ? "iconDiv icon3"
                          : "iconDiv icon4"
                      }
                    >
                      {item.category} -{" "}
                    </div>
                    <input
                      type="text"
                      value={item.question}
                      onChange={(e) => {
                        const newQuestionsArray = [...questionsArray];
                        newQuestionsArray[index].question = e.target.value;
                        setQuestionsArray(newQuestionsArray);
                      }}
                    />
                    {index === 0 ? (
                      <Button
                        text={" ˄ "}
                        color={"grey"}
                        func={() => {}}
                        show={true}
                      />
                    ) : (
                      <Button
                        text={" ˄ "}
                        color={"white"}
                        func={() => {}}
                        show={true}
                      />
                    )}
                    {index === questionsArray.length - 1 ? (
                      <Button
                        text={" ˅ "}
                        color={"grey"}
                        func={() => {}}
                        show={true}
                      />
                    ) : (
                      <Button
                        text={" ˅ "}
                        color={"white"}
                        func={() => {}}
                        show={true}
                      />
                    )}
                    <Button
                      text={" X "}
                      color={"whitered"}
                      func={() => {
                        const newQuestionsArray = [...questionsArray];
                        newQuestionsArray.splice(index, 1);
                        setQuestionsArray(newQuestionsArray);
                      }}
                      show={true}
                    />
                  </div>
                );
              })}
            </div>
            <div className="createButtons">
              <Button
                text={"Ajouter une question Texte"}
                color={"lightgreen"}
                func={() => {
                  const newQuestionsArray = [...questionsArray];
                  newQuestionsArray.push({ question: "", category: 1 });
                  setQuestionsArray(newQuestionsArray);
                }}
                show={true}
              />
              <Button
                text={"Ajouter une question Note"}
                color={"lightgreen"}
                func={() => {
                  const newQuestionsArray = [...questionsArray];
                  newQuestionsArray.push({ question: "", category: 2 });
                  setQuestionsArray(newQuestionsArray);
                }}
                show={true}
              />
              <Button
                text={"Ajouter une question Email"}
                color={"lightgreen"}
                func={() => {
                  const newQuestionsArray = [...questionsArray];
                  newQuestionsArray.push({ question: "", category: 3 });
                  setQuestionsArray(newQuestionsArray);
                }}
                show={true}
              />
              <Button
                text={"Ajouter une question Oui/Non"}
                color={"lightgreen"}
                func={() => {
                  const newQuestionsArray = [...questionsArray];
                  newQuestionsArray.push({ question: "", category: 4 });
                  setQuestionsArray(newQuestionsArray);
                }}
                show={true}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CreateForm;
